<script setup lang="ts">
/**
 * UI-kit component
 * Category: ⚠️ Info elements/other
 * Name: 'Tooltip'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=7680-5414'
 */

defineOptions({
  name: 'TooltipDefault',
})

withDefaults(defineProps<TooltipDefaultProps>(), {
  text: '',
  size: 'default',
  placement: 'left',
})

interface TooltipDefaultProps {
  text?: string
  size?: 'default' | 'small'
  placement?: 'left' | 'center' | 'right'
}

</script>

<template>
  <div :class="['tooltip', size, placement]">
    <div class="tooltip__box">
      <template v-if="text">
        <span
          class="tooltip__text"
          v-html="text"
        />
      </template>
      <template v-else>
        <slot />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TooltipDefault.scss" />
